<template>
  <div style="background:#ffffff;margin-top: 3%;">
    <div id="income" style="height:40vh;width:100%"></div>
    <div style="height: 70px; margin-left: 10%">
      <el-radio-group
        v-model="dataType" @change="changeDataType">
        <el-radio v-for="item in dataTypeList"
                  :label="item.value">{{ item.label }}
        </el-radio>
      </el-radio-group>
    </div>
  </div>
</template>

<script>
import * as echarts from "echarts/core";
import {LineChart, BarChart} from "echarts/charts";
import {CanvasRenderer} from "echarts/renderers";
import {
  GridComponent,
  TooltipComponent,
  TitleComponent,
  LegendComponent,
  ToolboxComponent,
} from "echarts/components";
import {groupByTimePrefix} from "@/util/util";

echarts.use([
  CanvasRenderer,
  LineChart,
  BarChart,
  TooltipComponent,
  GridComponent,
  TitleComponent,
  LegendComponent,
  ToolboxComponent,
]);

export default {
  name: "echartTimeComparison",
  props: ['listData', 'title'],//传入的数据和表名
  data() {
    return {
      // 图表的数据
      chartData: {
        series: [],
        legendData: []
      },
      dataTypeList: [
        {value: 'reqSmt', label: '请求数'},
        {value: 'resSmt', label: '填充数'},
        {value: 'uniShowSmt', label: '展示数'},
        {value: 'uniClkSmt', label: '点击数'},
        {value: 'fillingRate', label: '填充率'},
        {value: 'effectiveFillingRate', label: '有效填充率'},
        {value: 'showRat', label: '展示率'},
        {value: 'effectiveShowRat', label: '有效展示率'},
        {value: 'clickRate', label: '点击率'},
        {value: 'originalWinPrice', label: '原始收入'},
        {value: 'originalEcpmAverage', label: '原始ECPM'},
      ],
      dataType: 'reqSmt',
      timer: undefined,
    };
  },
  watch: {
    listData() {
      this.initIncomeChar();
    }
  },
  mounted() {
    //图表的大小随浏览器的大小变化而变化
    window.onresize = () => {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.incomeChart.resize();
      }, 100);
    };
  },
  methods: {
    initIncomeChar() {
      const chartDom = document.getElementById("income");
      this.incomeChart = echarts.init(chartDom);
      this.incomeChart.clear();
      this.getIncomeData(this.listData);
    },
    incomeSetOption() {
      const option = {
        title: {
          text: this.title
        },
        tooltip: {
          trigger: "axis"
        },
        legend: {
          data: this.chartData.legendData
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          },
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: ['0点', '1点', '2点', '3点', '4点', '5点', '6点', '7点', '8点', '9点', '10点', '11点', '12点', '13点', '14点', '15点', '16点', '17点', '18点', '19点', '20点', '21点', '22点', '23点']
        },
        yAxis: {
          type: 'value'
        },
        series: this.chartData.series,
      };
      option && this.incomeChart.setOption(option);
    },
    getIncomeData(data) {
      this.chartData = {
        series: [],
        legendData: []
      };
      let groupData = groupByTimePrefix(data, 'reportTime', this.dataType);
      Object.keys(groupData).forEach(key => {
        const data = groupData[key];
        const serie = {
          name: key,
          type: 'line',
          smooth: true,
          data: data
        }
        this.chartData.series.push(serie)
        this.chartData.legendData.push(key)
      });
      this.incomeSetOption();
    },
    changeDataType() {
      this.getIncomeData(this.listData)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
